import { isNumber } from 'lodash';

import { Action } from '../actions';
import {
    APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR,
    APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
    APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR,
    APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
    ApplyEndTimeForTimeTargetingEditor,
    ApplyEndTimeHolidaysForTimeTargetingEditor,
    ApplyStartTimeForTimeTargetingEditor,
    ApplyStartTimeHolidaysForTimeTargetingEditor,
    CANCEL_TIME_TARGETING_EDITOR,
    CancelTimeTargetingEditor,
    CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR,
    CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR,
    CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
    CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR,
    CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
    CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR,
    CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
    ChangeBoardValuesForTimeTargetingEditor,
    ChangeEndTimeHolidaysForTimeTargetingEditor,
    ChangeRateCorrectionsHolidaysForTimeTargetingEditor,
    ChangeStartTimeHolidaysForTimeTargetingEditor,
    CLOSE_TIME_TARGETING_EDITOR,
    QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR,
    QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR,
    QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR,
    QuickCheckDayForTimeTargetingEditor,
    QuickSelectDaysForTimeTargetingEditor,
    QuickSelectHoursForTimeTargetingEditor,
    SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR,
    SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR,
    SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR,
    SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR,
    SelectBoardColumnForTimeTargetingEditor,
    SelectBoardRowForTimeTargetingEditor,
    SelectCountryTimeZoneForTimeTargetingEditor,
    SelectTimeZoneForTimeTargetingEditor,
    SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR,
    SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR,
    SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR,
    SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR,
    SwitchEnabledRateCorrectionsForTimeTargetingEditor,
    SwitchShowModeHolidaysForTimeTargetingEditor,
    UPDATE_TIME_TARGETING_EDITOR,
    UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR,
    UpdateTimeTargetingEditor
} from '../actions/timeTargetingEditor';
import { HOURS_PER_DAY } from '../constants';
import { getTimeTargetingEditorDataFromTimeTargetingValue } from '../mappers/campaignsEdit/campaignsEdit';
import {
    formatTimeStringToNumber,
    getRoundedHoursByMinutes
} from '../service/TimeHelper/TimeHelper';
import {
    DEFAULT_RATE_CORRECTIONS_VALUE,
    getChangedTimeBoard,
    getCorrectEndTimeForTimeTargetingEditor,
    getCorrectStartTimeForTimeTargetingEditor,
    getHourIndexFromEndHourTimeForTimeTargeting,
    getHoursRangeItemByRange,
    getHoursRangeItemForTimeTargeting,
    getListSelectedRowForTimeTargetingBoard,
    getSelectedDaysRangeForTimeTargeting,
    getTimeRangeByHoursRangeItem,
    hasSpecificSelectedItemsTimeTargetingBoardByIndexColumn,
    hasSpecificSelectedItemsTimeTargetingBoardByIndexRow,
    listTimeTargetingHoursMenuItems,
    selectAreaAtTimeTargetingBoard,
    TimeTargetingHoursSelectType
} from '../service/TimeTargetingEditorHelper/TimeTargetingEditorHelper';
import { State } from '../typings/state';
import { TimeTargetingEditorsState } from '../typings/timeTargetingEditor';

const quickSelectDaysForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: QuickSelectDaysForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, selectedDays } = action;
    const currentEditor = state[editorId];
    const {
        timeBoard,
        rateCorrections = DEFAULT_RATE_CORRECTIONS_VALUE
    } = currentEditor;
    let currentHoursRangeItem = getHoursRangeItemForTimeTargeting(timeBoard);

    // в случае произвольного временного интервала нужно переключить временной интервал в круглосуточно
    if (currentHoursRangeItem.id === TimeTargetingHoursSelectType.ARBITRARY) {
        currentHoursRangeItem = listTimeTargetingHoursMenuItems[0];
    }

    const currentDaysRangeItem = getSelectedDaysRangeForTimeTargeting(
        selectedDays
    );
    const newTimeBoard = getChangedTimeBoard(
        timeBoard,
        selectedDays,
        currentHoursRangeItem,
        rateCorrections
    );

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            currentHoursRangeItem: currentHoursRangeItem,
            currentDaysRangeItem: currentDaysRangeItem,
            timeBoard: newTimeBoard,
            selectedDays
        }
    };
};

const quickCheckDayForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: QuickCheckDayForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, indexDay } = action;
    const currentEditor = state[editorId];
    const {
        timeBoard,
        selectedDays,
        rateCorrections = DEFAULT_RATE_CORRECTIONS_VALUE
    } = currentEditor;
    const isSelectedDay = selectedDays.includes(indexDay);
    const newSelectedDays = isSelectedDay
        ? selectedDays.filter(selectedDayIndex => selectedDayIndex !== indexDay)
        : [...selectedDays, indexDay];

    const currentHoursRangeItem = getHoursRangeItemForTimeTargeting(timeBoard);
    const currentDaysRangeItem = getSelectedDaysRangeForTimeTargeting(
        newSelectedDays
    );
    let newTimeBoard = getChangedTimeBoard(
        timeBoard,
        newSelectedDays,
        currentHoursRangeItem,
        rateCorrections
    );

    // в случае произвольного временного интервала нужно для чекнутого элемента выбрать весь диапазон
    if (
        !isSelectedDay &&
        currentHoursRangeItem.id === TimeTargetingHoursSelectType.ARBITRARY
    ) {
        newTimeBoard = selectAreaAtTimeTargetingBoard(
            newTimeBoard,
            {
                indexHour: 0,
                indexDay: indexDay
            },
            {
                indexHour: getHourIndexFromEndHourTimeForTimeTargeting(
                    HOURS_PER_DAY
                ),
                indexDay: indexDay
            },
            rateCorrections
        );
    }

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            currentHoursRangeItem: currentHoursRangeItem,
            currentDaysRangeItem: currentDaysRangeItem,
            timeBoard: newTimeBoard,
            selectedDays: newSelectedDays
        }
    };
};

const updateTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: UpdateTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, value } = action;

    return {
        ...state,
        [editorId]: {
            ...value
        }
    };
};

const quickSelectHoursForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: QuickSelectHoursForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, selectedType } = action;
    const currentEditor = state[editorId];
    const {
        selectedDays,
        timeBoard,
        rateCorrections = DEFAULT_RATE_CORRECTIONS_VALUE
    } = currentEditor;
    const currentHoursRangeItem = listTimeTargetingHoursMenuItems.find(
        item => item.id === selectedType
    );
    const currentDaysRangeItem = getSelectedDaysRangeForTimeTargeting(
        selectedDays
    );

    if (!currentHoursRangeItem) {
        return state;
    }

    const newTimeBoard = getChangedTimeBoard(
        timeBoard,
        selectedDays,
        currentHoursRangeItem,
        rateCorrections
    );

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            selectedDays: selectedDays,
            currentDaysRangeItem: currentDaysRangeItem,
            currentHoursRangeItem: currentHoursRangeItem,
            timeBoard: newTimeBoard,
            ...getTimeRangeByHoursRangeItem(currentHoursRangeItem)
        }
    };
};

const applyStartTimeForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ApplyStartTimeForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId } = action;
    const currentEditor = state[editorId];
    const {
        startTime,
        endTime,
        timeBoard,
        selectedDays,
        rateCorrections = DEFAULT_RATE_CORRECTIONS_VALUE
    } = currentEditor;
    const currentHoursRangeItem = getHoursRangeItemForTimeTargeting(timeBoard);

    if (currentHoursRangeItem.id === TimeTargetingHoursSelectType.ARBITRARY) {
        return state;
    }

    const { endHour } = currentHoursRangeItem;
    const { startTime: lastStartTime } = getTimeRangeByHoursRangeItem(
        currentHoursRangeItem
    );
    const newInputStartTime = getCorrectStartTimeForTimeTargetingEditor(
        startTime,
        endTime,
        lastStartTime
    );
    const formattedTime = formatTimeStringToNumber(newInputStartTime);

    if (!formattedTime) {
        return state;
    }

    const newStartHour = getRoundedHoursByMinutes(formattedTime);
    const newHoursRangeItem = getHoursRangeItemByRange({
        startHour: newStartHour,
        endHour
    });

    const newTimeBoard = getChangedTimeBoard(
        timeBoard,
        selectedDays,
        newHoursRangeItem,
        rateCorrections
    );

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            startTime: newInputStartTime,
            currentHoursRangeItem: newHoursRangeItem,
            timeBoard: newTimeBoard
        }
    };
};

const applyEndTimeForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ApplyEndTimeForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId } = action;
    const currentEditor = state[editorId];
    const {
        endTime,
        startTime,
        timeBoard,
        selectedDays,
        rateCorrections = DEFAULT_RATE_CORRECTIONS_VALUE
    } = currentEditor;
    const currentHoursRangeItem = getHoursRangeItemForTimeTargeting(timeBoard);

    if (currentHoursRangeItem.id === TimeTargetingHoursSelectType.ARBITRARY) {
        return state;
    }

    const { startHour } = currentHoursRangeItem;
    const { endTime: lastEndTime } = getTimeRangeByHoursRangeItem(
        currentHoursRangeItem
    );
    const newInputEndTime = getCorrectEndTimeForTimeTargetingEditor(
        endTime,
        startTime,
        lastEndTime
    );
    const formattedTime = formatTimeStringToNumber(newInputEndTime);

    if (!formattedTime) {
        return state;
    }

    const newEndHour = getRoundedHoursByMinutes(formattedTime);
    const newHoursRangeItem = getHoursRangeItemByRange({
        startHour,
        endHour: getHourIndexFromEndHourTimeForTimeTargeting(newEndHour)
    });

    const newTimeBoard = getChangedTimeBoard(
        timeBoard,
        selectedDays,
        newHoursRangeItem,
        rateCorrections
    );

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            endTime: newInputEndTime,
            currentHoursRangeItem: newHoursRangeItem,
            timeBoard: newTimeBoard
        }
    };
};

export const switchEnabledRateCorrectionsForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: SwitchEnabledRateCorrectionsForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId } = action;
    const currentEditor = state[editorId];
    const { rateCorrections } = currentEditor;

    const newRateCorrections = isNumber(rateCorrections)
        ? undefined
        : DEFAULT_RATE_CORRECTIONS_VALUE;

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            rateCorrections: newRateCorrections
        }
    };
};

export const selectBoardColumnForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: SelectBoardColumnForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, index: indexHour } = action;
    const currentEditor = state[editorId];
    const {
        timeBoard,
        rateCorrections = DEFAULT_RATE_CORRECTIONS_VALUE
    } = currentEditor;

    const hasNotSelectedItems = hasSpecificSelectedItemsTimeTargetingBoardByIndexColumn(
        timeBoard,
        indexHour,
        false
    );
    const newRateCorrectionValue = hasNotSelectedItems ? rateCorrections : 0;

    const newTimeBoard = selectAreaAtTimeTargetingBoard(
        timeBoard,
        {
            indexDay: 0,
            indexHour: indexHour
        },
        {
            indexDay: timeBoard.length,
            indexHour: indexHour
        },
        newRateCorrectionValue
    );
    const listSelectedDaysRows = getListSelectedRowForTimeTargetingBoard(
        newTimeBoard
    );
    const currentHoursRangeItem = getHoursRangeItemForTimeTargeting(
        newTimeBoard
    );
    const currentDaysRangeItem = getSelectedDaysRangeForTimeTargeting(
        listSelectedDaysRows
    );
    const { startTime, endTime } = getTimeRangeByHoursRangeItem(
        currentHoursRangeItem
    );

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            timeBoard: newTimeBoard,
            selectedDays: listSelectedDaysRows,
            currentHoursRangeItem,
            currentDaysRangeItem,
            startTime,
            endTime
        }
    };
};

export const selectBoardRowForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: SelectBoardRowForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, index: indexDay } = action;
    const currentEditor = state[editorId];
    const {
        timeBoard,
        rateCorrections = DEFAULT_RATE_CORRECTIONS_VALUE
    } = currentEditor;

    const hasNotSelectedItems = hasSpecificSelectedItemsTimeTargetingBoardByIndexRow(
        timeBoard,
        indexDay,
        false
    );
    const newRateCorrectionValue = hasNotSelectedItems ? rateCorrections : 0;

    const newTimeBoard = selectAreaAtTimeTargetingBoard(
        timeBoard,
        {
            indexDay: indexDay,
            indexHour: 0
        },
        {
            indexDay: indexDay,
            indexHour: timeBoard[indexDay].length
        },
        newRateCorrectionValue
    );
    const listSelectedDaysRows = getListSelectedRowForTimeTargetingBoard(
        newTimeBoard
    );
    const currentHoursRangeItem = getHoursRangeItemForTimeTargeting(
        newTimeBoard
    );
    const currentDaysRangeItem = getSelectedDaysRangeForTimeTargeting(
        listSelectedDaysRows
    );
    const { startTime, endTime } = getTimeRangeByHoursRangeItem(
        currentHoursRangeItem
    );

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            timeBoard: newTimeBoard,
            selectedDays: listSelectedDaysRows,
            currentHoursRangeItem,
            currentDaysRangeItem,
            startTime,
            endTime
        }
    };
};

export const changeBoardValuesForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ChangeBoardValuesForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { start, end, value, editorId } = action;
    const currentEditor = state[editorId];
    const { timeBoard } = currentEditor;

    const newTimeBoard = selectAreaAtTimeTargetingBoard(
        timeBoard,
        start,
        end,
        value
    );
    const listSelectedDaysRows = getListSelectedRowForTimeTargetingBoard(
        newTimeBoard
    );
    const currentHoursRangeItem = getHoursRangeItemForTimeTargeting(
        newTimeBoard
    );
    const currentDaysRangeItem = getSelectedDaysRangeForTimeTargeting(
        listSelectedDaysRows
    );
    const { startTime, endTime } = getTimeRangeByHoursRangeItem(
        currentHoursRangeItem
    );

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            timeBoard: newTimeBoard,
            selectedDays: listSelectedDaysRows,
            currentHoursRangeItem,
            currentDaysRangeItem,
            startTime,
            endTime
        }
    };
};

export const cancelTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: CancelTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, value } = action;
    const editorData = getTimeTargetingEditorDataFromTimeTargetingValue(value);

    return {
        ...state,
        [editorId]: {
            ...editorData,
            isOpened: false
        }
    };
};

export const switchShowModeHolidaysForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: SwitchShowModeHolidaysForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, value } = action;
    const currentEditor = state[editorId];
    const { holidaysSettings } = currentEditor;

    return {
        ...state,
        [editorId]: {
            ...currentEditor,
            holidaysSettings: {
                ...holidaysSettings,
                isShow: value
            }
        }
    };
};

export const changeStartTimeHolidaysForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ChangeStartTimeHolidaysForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, value } = action;
    const currentEditor = state[editorId];
    const { holidaysSettings } = currentEditor;

    return {
        ...state,
        [action.editorId]: {
            ...currentEditor,
            holidaysSettings: {
                ...holidaysSettings,
                startTime: value
            }
        }
    };
};

export const applyStartTimeHolidaysForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ApplyStartTimeHolidaysForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId } = action;
    const currentEditor = state[editorId];
    const { holidaysSettings } = currentEditor;
    const { currentHoursRangeItem, startTime, endTime } = holidaysSettings;

    if (currentHoursRangeItem.id === TimeTargetingHoursSelectType.ARBITRARY) {
        return state;
    }

    const { endHour } = currentHoursRangeItem;
    const { startTime: lastStartTime } = getTimeRangeByHoursRangeItem(
        currentHoursRangeItem
    );
    const newInputStartTime = getCorrectStartTimeForTimeTargetingEditor(
        startTime,
        endTime,
        lastStartTime
    );
    const formattedTime = formatTimeStringToNumber(newInputStartTime);

    if (!formattedTime) {
        return state;
    }

    const newStartHour = getRoundedHoursByMinutes(formattedTime);
    const newHoursRangeItem = getHoursRangeItemByRange({
        startHour: newStartHour,
        endHour
    });

    return {
        ...state,
        [action.editorId]: {
            ...currentEditor,
            holidaysSettings: {
                ...holidaysSettings,
                startTime: newInputStartTime,
                currentHoursRangeItem: newHoursRangeItem
            }
        }
    };
};

export const changeEndTimeHolidaysForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ChangeEndTimeHolidaysForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, value } = action;
    const currentEditor = state[editorId];
    const { holidaysSettings } = currentEditor;

    return {
        ...state,
        [action.editorId]: {
            ...currentEditor,
            holidaysSettings: {
                ...holidaysSettings,
                endTime: value
            }
        }
    };
};

export const applyEndTimeHolidaysForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ApplyEndTimeHolidaysForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId } = action;
    const currentEditor = state[editorId];
    const { holidaysSettings } = currentEditor;
    const { currentHoursRangeItem, startTime, endTime } = holidaysSettings;

    if (currentHoursRangeItem.id === TimeTargetingHoursSelectType.ARBITRARY) {
        return state;
    }

    const { startHour } = currentHoursRangeItem;
    const { endTime: lastEndTime } = getTimeRangeByHoursRangeItem(
        currentHoursRangeItem
    );
    const newInputEndTime = getCorrectEndTimeForTimeTargetingEditor(
        endTime,
        startTime,
        lastEndTime
    );
    const formattedTime = formatTimeStringToNumber(newInputEndTime);

    if (!formattedTime) {
        return state;
    }

    const newEndHour = getRoundedHoursByMinutes(formattedTime);
    const newHoursRangeItem = getHoursRangeItemByRange({
        startHour,
        endHour: getHourIndexFromEndHourTimeForTimeTargeting(newEndHour)
    });

    return {
        ...state,
        [action.editorId]: {
            ...currentEditor,
            holidaysSettings: {
                ...holidaysSettings,
                endTime: newInputEndTime,
                currentHoursRangeItem: newHoursRangeItem
            }
        }
    };
};

export const changeRateCorrectionsHolidaysForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: ChangeRateCorrectionsHolidaysForTimeTargetingEditor
): TimeTargetingEditorsState => {
    const { editorId, value } = action;
    const currentEditor = state[editorId];
    const { holidaysSettings } = currentEditor;

    return {
        ...state,
        [action.editorId]: {
            ...currentEditor,
            holidaysSettings: {
                ...holidaysSettings,
                rateCorrections: value
            }
        }
    };
};

export const selectCountryTimeZoneForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: SelectCountryTimeZoneForTimeTargetingEditor,
    fullState: State
): TimeTargetingEditorsState => {
    const { timeZoneGroups } = fullState.commonData;
    const { editorId, id } = action;
    const currentEditor = state[editorId];

    if (timeZoneGroups === undefined) {
        return state;
    }

    const selectedTimeZoneGroup = timeZoneGroups.find(
        timeZoneGroup => timeZoneGroup.id === id
    );

    if (
        selectedTimeZoneGroup === undefined ||
        selectedTimeZoneGroup.timezones.length === 0
    ) {
        return state;
    }

    return {
        ...state,
        [action.editorId]: {
            ...currentEditor,
            idTimeZone: selectedTimeZoneGroup.timezones[0].id,
            idTimeZoneGroup: id
        }
    };
};

export const selectTimeZoneForTimeTargetingEditor = (
    state: TimeTargetingEditorsState,
    action: SelectTimeZoneForTimeTargetingEditor,
    fullState: State
): TimeTargetingEditorsState => {
    const { editorId, id } = action;
    const currentEditor = state[editorId];

    return {
        ...state,
        [action.editorId]: {
            ...currentEditor,
            idTimeZone: id
        }
    };
};

export function timeTargetingEditor(
    state: TimeTargetingEditorsState = {},
    action: Action,
    fullState: State
): TimeTargetingEditorsState {
    switch (action.type) {
        case UPDATE_TIME_TARGETING_EDITOR:
            return updateTimeTargetingEditor(state, action);

        case QUICK_SELECT_DAYS_FOR_TIME_TARGETING_EDITOR:
            return quickSelectDaysForTimeTargetingEditor(state, action);

        case QUICK_SELECT_HOURS_FOR_TIME_TARGETING_EDITOR:
            return quickSelectHoursForTimeTargetingEditor(state, action);

        case CLOSE_TIME_TARGETING_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    isOpened: false
                }
            };

        case CHANGE_START_TIME_FOR_TIME_TARGETING_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    startTime: action.value
                }
            };

        case CHANGE_END_TIME_FOR_TIME_TARGETING_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    endTime: action.value
                }
            };

        case APPLY_START_TIME_FOR_TIME_TARGETING_EDITOR:
            return applyStartTimeForTimeTargetingEditor(state, action);

        case APPLY_END_TIME_FOR_TIME_TARGETING_EDITOR:
            return applyEndTimeForTimeTargetingEditor(state, action);

        case CHANGE_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR:
            return changeStartTimeHolidaysForTimeTargetingEditor(state, action);

        case CHANGE_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR:
            return changeEndTimeHolidaysForTimeTargetingEditor(state, action);

        case APPLY_START_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR:
            return applyStartTimeHolidaysForTimeTargetingEditor(state, action);

        case APPLY_END_TIME_HOLIDAYS_FOR_TIME_TARGETING_EDITOR:
            return applyEndTimeHolidaysForTimeTargetingEditor(state, action);

        case CHANGE_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR:
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    rateCorrections: action.value
                }
            };

        case SWITCH_ENABLED_RATE_CORRECTIONS_FOR_TIME_TARGETING_EDITOR:
            return switchEnabledRateCorrectionsForTimeTargetingEditor(
                state,
                action
            );

        case CHANGE_BOARD_VALUES_FOR_TIME_TARGETING_EDITOR:
            return changeBoardValuesForTimeTargetingEditor(state, action);

        case SELECT_BOARD_COLUMN_FOR_TIME_TARGETING_EDITOR:
            return selectBoardColumnForTimeTargetingEditor(state, action);

        case SELECT_BOARD_ROW_FOR_TIME_TARGETING_EDITOR:
            return selectBoardRowForTimeTargetingEditor(state, action);

        case CANCEL_TIME_TARGETING_EDITOR:
            return cancelTimeTargetingEditor(state, action);

        case UPDATE_VALIDATION_DATA_FOR_TIME_TARGETING_EDITOR:
            // сюда еще нужно будет положить объект валидации
            return {
                ...state,
                [action.editorId]: {
                    ...state[action.editorId],
                    isOpened: false
                }
            };

        case QUICK_CHECK_DAY_FOR_TIME_TARGETING_EDITOR:
            return quickCheckDayForTimeTargetingEditor(state, action);

        case SWITCH_WORKING_WEEKENDS_FOR_TIME_TARGETING_EDITOR:
            const editor = state[action.editorId];

            return {
                ...state,
                [action.editorId]: {
                    ...editor,
                    useWorkingWeekends: !editor.useWorkingWeekends
                }
            };

        case SWITCH_HOLIDAYS_MODE_FOR_TIME_TARGETING_EDITOR:
            const currentEditor = state[action.editorId];

            return {
                ...state,
                [action.editorId]: {
                    ...currentEditor,
                    enabledHolidaysMode: !currentEditor.enabledHolidaysMode
                }
            };

        case SWITCH_SHOW_MODE_HOLIDAYS_FOR_TIME_TARGETING_EDITOR:
            return switchShowModeHolidaysForTimeTargetingEditor(state, action);

        case CHANGE_RATE_CORRECTIONS_HOLIDAYS_FOR_TIME_TARGETING_EDITOR:
            return changeRateCorrectionsHolidaysForTimeTargetingEditor(
                state,
                action
            );

        case SELECT_COUNTRY_TIME_ZONE_FOR_TIME_TARGETING_EDITOR:
            return selectCountryTimeZoneForTimeTargetingEditor(
                state,
                action,
                fullState
            );

        case SELECT_TIME_ZONE_FOR_TIME_TARGETING_EDITOR:
            return selectTimeZoneForTimeTargetingEditor(
                state,
                action,
                fullState
            );

        default:
            return state;
    }
}
